import React, { useMemo } from 'react';
import { Skeleton, Space } from 'antd';
import styles from './loadings.module.scss';
export const MailDetailLoading = () => useMemo(() => (React.createElement("div", { className: styles.loadingWrap, style: {
        padding: '30px',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    } },
    React.createElement(Space, null,
        React.createElement(Skeleton.Button, { shape: "round" }),
        React.createElement(Skeleton.Button, { shape: "round" }),
        React.createElement(Skeleton.Button, { shape: "round" }),
        React.createElement(Skeleton.Button, { shape: "round" }),
        React.createElement(Skeleton.Button, { shape: "round" }),
        React.createElement(Skeleton.Button, { shape: "round" })),
    React.createElement("br", null),
    React.createElement("br", null),
    React.createElement(Skeleton, { paragraph: { rows: 0 }, size: "large" }),
    React.createElement(Skeleton, { avatar: true, paragraph: { rows: 1 } }),
    React.createElement("br", null),
    React.createElement(Skeleton, { paragraph: { rows: 100 } }))), []);
export const MergeMailLoading = () => (React.createElement("div", { style: {
        margin: '12px 20px 0',
        backgroundColor: '#fff',
        borderRadius: '4px',
        height: '56px',
        overflow: 'hidden',
        paddingLeft: '20px',
        paddingTop: '8px',
    } },
    React.createElement(Skeleton, { active: true, avatar: true, title: { width: '90%' } })));
export const SingleMailLoading = () => (React.createElement("div", { style: {
        width: '100%',
        background: '#FFFFFF',
        height: '320px',
        overflow: 'hidden',
        padding: '20px',
    } },
    React.createElement(Skeleton, { active: true, paragraph: { rows: 7 } })));
export default MailDetailLoading;
